<div *ngIf="column.actionPerformedOnDropdown" class="filterheight overflow-auto">
  
    <ul class="list-group">
      <li class="list-group-item filter-header">Filters</li> 
      <li class="list-group-item">
        <span>
          <span class="icon-ic_checkbox" *ngIf="selectAllActionPerformedOnType.isChecked"
            (click)="selectAllActionPerformedOnType.isChecked = false;selectAllActionPerformedOnTypeFilter(selectAllActionPerformedOnType.isChecked)"></span>
          <span class="icon-ic_checkbox_all" *ngIf="!selectAllActionPerformedOnType.isChecked"
            (click)="selectAllActionPerformedOnType.isChecked = true;selectAllActionPerformedOnTypeFilter(selectAllActionPerformedOnType.isChecked)"></span>
          <span class="ml-2"
            (click)="selectAllActionPerformedOnType.isChecked = !selectAllActionPerformedOnType.isChecked; selectAllActionPerformedOnTypeFilter(selectAllActionPerformedOnType.isChecked)">All</span>
        </span>
      </li>
      <li class="list-group-item" *ngFor="let tyarray of actionPerformedOnArray">
        <span>
          <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(actionPerformedOnArray,selectAllActionPerformedOnType,tyarray.isCheck)"></span>
          <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(actionPerformedOnArray,selectAllActionPerformedOnType,tyarray.isCheck)"></span>
          <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(actionPerformedOnArray,selectAllActionPerformedOnType,tyarray.isCheck)">{{tyarray.description}}</span>
        </span>
      </li>
    </ul>
  </div>
  <div *ngIf="column.actionPerformedDropdown" class="filterheight overflow-auto">
  
    <ul class="list-group">
      <li class="list-group-item filter-header">Filters</li> 
      <li class="list-group-item">
        <span>
          <span class="icon-ic_checkbox" *ngIf="selectAllActionPerformedType.isChecked"
            (click)="selectAllActionPerformedType.isChecked = false;selectAllActionPerformedTypeFilter(selectAllActionPerformedType.isChecked)"></span>
          <span class="icon-ic_checkbox_all" *ngIf="!selectAllActionPerformedType.isChecked"
            (click)="selectAllActionPerformedType.isChecked = true;selectAllActionPerformedTypeFilter(selectAllActionPerformedType.isChecked)"></span>
          <span class="ml-2"
            (click)="selectAllActionPerformedType.isChecked = !selectAllActionPerformedType.isChecked; selectAllActionPerformedTypeFilter(selectAllActionPerformedType.isChecked)">All</span>
        </span>
      </li>
      <li class="list-group-item" *ngFor="let tyarray of actionPerformedArray">
        <span>
          <span class="icon-ic_checkbox" *ngIf="tyarray.isCheck" (click)="tyarray.isCheck=false;togglefilter(actionPerformedArray,selectAllActionPerformedType,tyarray.isCheck)"></span>
          <span class="icon-ic_checkbox_unexpected" *ngIf="!tyarray.isCheck" (click)="tyarray.isCheck=true;togglefilter(actionPerformedArray,selectAllActionPerformedType,tyarray.isCheck)"></span>
          <span class="ml-2" (click)="tyarray.isCheck = !tyarray.isCheck;togglefilter(actionPerformedArray,selectAllActionPerformedType,tyarray.isCheck)">{{tyarray.description}}</span>
        </span>
      </li>
    </ul>
  </div>
  <div class="d-flex justify-content-between mx-2 mt-3 mb-3">
    <button (click)="resetEvents()" class="button sm" type="button">
      Cancel
    </button>
    <button (click)="onFilterApply(column)" class="button blue smblue" style="float: right;" type="button">
      Apply
    </button>
  </div>
